export default "__VITE_ASSET__C2x01Y8e__"